import React, { useEffect, useState } from "react";
import { CheckCircle, XCircle, AlertCircle, X } from "lucide-react";
import "./Toast.css";

const Toast = ({ message, type, onClose }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(onClose, 4000); // Match exit animation duration
  };

  const getIcon = () => {
    switch (type) {
      case "success": return <CheckCircle size={24} />;
      case "error": return <XCircle size={24} />;
      default: return <AlertCircle size={24} />;
    }
  };

  return (
    <div className={`toast-hud ${type} ${isExiting ? 'exit' : ''}`}>
      <div className="toast-icon">
        {getIcon()}
      </div>
      <div className="toast-body">
        <p className="toast-message">{message}</p>
      </div>
      <button className="toast-close" onClick={handleClose}>
        <X size={18} />
      </button>
      <div className="toast-pulse" style={{ animation: 'toast-drain 5s linear forwards' }}></div>
      <style jsx="true">{`
        @keyframes toast-drain {
          from { width: 100%; }
          to { width: 0%; }
        }
      `}</style>
    </div>
  );
};

export default Toast;
